import { useTranslation } from 'react-i18next'
import { SvgIconComponent } from '@mui/icons-material'
import { SvgIconComponent as CustomSvgIconComponent } from 'shared/types'
import {
  ListItem,
  ListItemButton,
  ListItemProps,
  ListItemText,
} from '@mui/material'
import ListItemIcon from './ListItemIcon'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { isGlobalworth, theme } from 'config'
import { ArrowDown, ArrowUp } from 'shared/assets'

export interface DrawerItemProps extends Partial<ListItemProps> {
  label?: string
  icon?: SvgIconComponent | CustomSvgIconComponent
  onClick(): void
  expanded?: boolean
  to?: string
}

const ExpandLessIcon = isGlobalworth ? (
  <ArrowUp />
) : (
  <ExpandLess sx={{ color: 'black' }} />
)
const ExpandMoreIcon = isGlobalworth ? (
  <ArrowDown />
) : (
  <ExpandMore sx={{ color: 'black' }} />
)

const DrawerItem = ({
  label,
  onClick,
  icon,
  expanded,
  className,
  ...props
}: DrawerItemProps) => {
  const { t } = useTranslation()
  const Icon = icon
  return (
    <ListItem
      disablePadding
      className={`${className || ''} ${expanded ? 'expanded' : ''}`}
      {...props}
    >
      <ListItemButton onClick={onClick}>
        {Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        {label && (
          <ListItemText
            primary={t(label)}
            primaryTypographyProps={{ color: 'inherit' }}
            sx={{
              color: theme.palette.text.secondary,
            }}
          />
        )}
        {expanded === undefined
          ? null
          : expanded
          ? ExpandLessIcon
          : ExpandMoreIcon}
      </ListItemButton>
    </ListItem>
  )
}

export default DrawerItem
